module.exports = __webpack_public_path__ + "img/routing.b7846203.png";